import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "@/components/site/Layout";
import ScrollToTop from "@/components/site/ScrollToTop";
import { AudioProvider } from "@/lib/audio";
import HomePage from "@/pages/HomePage";
import PilotPage from "@/pages/PilotPage";
import NationsPage from "@/pages/NationsPage";
import CharactersPage from "@/pages/CharactersPage";
import CommunityPage from "@/pages/CommunityPage";
import QuizPage from "@/pages/QuizPage";
import MissionPage from "@/pages/MissionPage";
import ArchivePage from "@/pages/ArchivePage";
import ArchiveAdminPage from "@/pages/ArchiveAdminPage";
import AnimeNYCPage from "@/pages/AnimeNYCPage";
import ArchiveWallPage from "@/pages/ArchiveWallPage";
import LoginPage from "@/pages/LoginPage";
import AuthCallbackPage from "@/pages/AuthCallbackPage";
import MyCastPage from "@/pages/MyCastPage";
import LeaderboardPage from "@/pages/LeaderboardPage";
import KeeperProfilePage from "@/pages/KeeperProfilePage";
import GalleryPage from "@/pages/GalleryPage";
import AdminStatsPage from "@/pages/AdminStatsPage";
import NotFoundPage from "@/pages/NotFoundPage";
import { AuthProvider, captureRef } from "@/lib/auth";

// Capture ?ref=... attribution as early as possible (e.g., ?ref=anime-nyc-table from booth QR).
if (typeof window !== "undefined") captureRef();

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <ScrollToTop />
        <AudioProvider>
          <Layout>
            <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/pilot" element={<PilotPage />} />
            <Route path="/nations" element={<NationsPage />} />
            <Route path="/characters" element={<CharactersPage />} />
            <Route path="/community" element={<CommunityPage />} />
            <Route path="/nation-quiz" element={<QuizPage />} />
            <Route path="/mission" element={<MissionPage />} />
            <Route path="/archive" element={<ArchiveWallPage />} />
            <Route path="/archive/drop" element={<ArchivePage />} />
            <Route path="/admin/archive" element={<ArchiveAdminPage />} />
            <Route path="/anime-nyc" element={<AnimeNYCPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/auth/callback" element={<AuthCallbackPage />} />
            <Route path="/me/cast" element={<MyCastPage />} />
            <Route path="/leaderboard" element={<LeaderboardPage />} />
            <Route path="/keeper/:username" element={<KeeperProfilePage />} />
            <Route path="/gallery" element={<GalleryPage />} />
            <Route path="/admin/stats" element={<AdminStatsPage />} />
            <Route path="*" element={<NotFoundPage />} />
            </Routes>
          </Layout>
        </AudioProvider>
      </BrowserRouter>
    </AuthProvider>
  );
}
